import PropTypes from 'prop-types';

import Button from '@mui/material/Button';

import RowMenu from '../RowMenu/RowMenu';

import classes from './PaymentCard.module.css';

const PaymentCard = ({ data, charges }) => {
  return (
    <>
      <div className={classes.cardsContainer}>
        <p className={classes.title}>{data.name}</p>
        {data.payments.map(item => (
          <aside
            className={classes.paymentCard}
            key={item.idUserPayment}
          >
            <div className={classes.cardGeneralInfo}>
              <p className={classes.paymentCardText}>
                {item.concept}
              </p>
              <p className={classes.paymentCardText}>
                {charges ? 'Fecha límite' : 'Fecha del pago'}{' '}
                {item.formatPayDate}
              </p>
              {item.status === 'NEXT' ? (
                <p className={classes.paymentCardText}>
                  $ {(item.amount / 100).toFixed(2)}
                  <span
                    style={{ color: '#df6016' }}
                    className={classes.iconPayment}
                  >
                    PRÓXIMO A VENCER
                  </span>
                </p>
              ) : item.status === 'PENDING' ? (
                <p className={classes.paymentCardText}>
                  $ {(item.amount / 100).toFixed(2)}
                  <span
                    style={{ color: '#d0021b' }}
                    className={classes.iconPayment}
                  >
                    VENCIDO
                  </span>
                </p>
              ) : (
                <p className={classes.paymentCardText}>
                  $ {(item.amount / 100).toFixed(2)}
                </p>
              )}
            </div>
            <div className={classes.cardSpecificContainer}>
              <Button
                className={
                  item.status === 'PAID'
                    ? classes.btnPaySuccess
                    : classes.paymentBtn
                }
                disabled={item.status === 'PAID'}
                component="a"
                href={`${process.env.REACT_APP_API_PATH_PAYMENT_URL}/cart/checkout/payment/${item.idConcept}/${item.idProgram}/${item.idUserPayment}`}
              >
                {item.status !== 'PAID' ? 'Pagar' : 'Pagado'}
              </Button>
              {item.status === 'PAID' && (
                <RowMenu
                  urlProduct={item.urlProduct}
                  isBilling={item.isBilling}
                  idUserPayment={item.idUserPayment}
                  send={item.send}
                />
              )}
            </div>
          </aside>
        ))}
      </div>
    </>
  );
};

PaymentCard.propTypes = {
  // eslint-disable-next-line react/require-default-props
  data: PropTypes.data,
  // eslint-disable-next-line react/require-default-props
  charges: PropTypes.bool
};

export default PaymentCard;
